export const APP_NAME = 'Spidipay';
export const roleTypes = [
  {
    id: 'ACCOUNTANT',
    label: 'Accountant',
    helperText: 'Can access the reports',
  },
  {
    id: 'PRODUCT_MANAGER',
    label: 'Product manager',
    helperText: 'Can add and edit products',
  },
  {
    id: 'DEVELOPER',
    label: 'Developer',
    helperText: 'Can manage API operators and access reports',
  },
  {
    id: 'BUSINESS_ADMIN',
    label: 'Business admin',
    helperText: 'Can manage user permissions and everything',
  },
];

/* 
interface Category {
  label: string;
  value: string;
}
 */
/* 
export const eventCategories: Category[] = [
  { label: 'Film', value: 'FILM' },
  { label: 'Music', value: 'MUSIC' },
  { label: 'Exhibition', value: 'EXHIBITION' },
  { label: 'Experience', value: 'EXPERIENCE' },
  { label: 'Kids', value: 'KIDS' },
  { label: 'Sport', value: 'SPORT' },
  { label: 'Theater', value: 'THEATER' },
];
 */
